import React from 'react';
import { User } from '@supabase/supabase-js';
import { AlertCircle } from 'lucide-react';
import AuthorDashboardSidebar from './AuthorDashboardSidebar';
import AssignmentManager from './assignments/AssignmentManager';
import ApplicationManager from './ApplicationManager';

interface AuthorDashboardProps {
  user: User;
}

export default function AuthorDashboard({ user }: AuthorDashboardProps) {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Development Notice - Full Width */}
      <div className="p-4 bg-blue-50 border-b border-blue-200">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-start gap-3">
            <AlertCircle className="w-5 h-5 text-blue-500 mt-0.5" />
            <div>
              <h3 className="font-medium text-blue-900">Beta Features Under Development</h3>
              <p className="text-blue-700 text-sm mt-1">
                The beta reading features are currently in active development. Report any errors via the Feedback link in the upper right menu.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content Area with Right Sidebar */}
      <div className="flex">
        {/* Main Content */}
        <div className="flex-1 overflow-y-auto">
          <div className="max-w-4xl mx-auto px-4 py-8 space-y-8">
            <AssignmentManager user={user} />
            <ApplicationManager user={user} />
          </div>
        </div>

        {/* Right Sidebar */}
        <AuthorDashboardSidebar user={user} />
      </div>
    </div>
  );
}